import { produce } from "immer";
import {
  resetGiftCard,
  updateGiftCard,
  updateGiftCardFormData,
} from "./actions";

const initialGiftCardState = {
  formData: {},
  voucherCode: null,
};

export const giftCardSlice = (set, get) => ({
  ...initialGiftCardState,
});

export const giftCardActions = (set, get) => ({
  [resetGiftCard]: () => {
    set((state) => ({
      ...state,
      giftCard: {
        ...initialGiftCardState,
      },
    }));
  },
  [updateGiftCard]: (payload) => {
    set((state) => ({
      ...state,
      giftCard: {
        ...state.giftCard,
        ...payload,
      },
    }));
  },
  [updateGiftCardFormData]: (data) => {
    set(
      produce((state) => {
        state.giftCard.formData = data;
      }),
    );
  },
});
